import { Status, States } from '@sift/resift/models/Status';

// ------------------------------------
// Constants
// ------------------------------------
import {
  ACTION_HANDLERS as clientActionHandlers,
  initialState as clientInitialState,
} from '@sift/resift/redux/reducers/client';

import createSingleActionHandlers from '@sift/resift/redux/reducers/createSingleActionHandlers';

export const FEATURE_UPDATE = 'FEATURE_UPDATE';
export const FEATURE_UPDATE_SUCCESS = 'FEATURE_UPDATE_SUCCESS';
export const FEATURE_UPDATE_ERROR = 'FEATURE_UPDATE_ERROR';

export const CLIENT_UPDATE = 'CLIENT_UPDATE';
export const CLIENT_UPDATE_SUCCESS = 'CLIENT_UPDATE_SUCCESS';
export const CLIENT_UPDATE_ERROR = 'CLIENT_UPDATE_ERROR';

// ------------------------------------
// Actions
// ------------------------------------

/**
 * Update features for a client
 * @param {Object} features the features object
 */
export function updateFeatures(features) {
  return {
    type: FEATURE_UPDATE,
    payload: {
      data: features,
    },
  };
}

export function updateClient(client) {
  return {
    type: CLIENT_UPDATE,
    payload: {
      data: client,
    },
  };
}

// ------------------------------------
// Actions Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  ...clientActionHandlers,
  ...createSingleActionHandlers({
    actionHandler: FEATURE_UPDATE,
    statusKey: 'featureStatus',
    dataKey: 'features',
  }),
  ...createSingleActionHandlers({
    actionHandler: CLIENT_UPDATE,
    statusKey: 'status',
    transparentStatus: true,
  }),
};

// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = {
  ...clientInitialState,
  terminology: {
    teamMember: 'Team Member',
    teamMember_plural: 'Team Members',
  },
  settings: {
    support: {
      enabled: false,
    },
  },

  featureStatus: new Status(States.NORMAL),
};

export default function clientReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}
